// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Lexend-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Lexend;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

:root {
  /* Primary colors */
  --color-white: #ffffff;
  --color-lightcream: #fffefa;
  /* --color-blue: #0078d4; "The over-used blue" */
  --color-blue: #0067b5;
  --color-orange: #f59e0b;
  --color-darkblue: #0067a3;
  --color-verydarkblue: #001944;

  /* Supporting colors */
  --color-gray: #6b7280;
  --color-lightblue: #bedaff5e;
  --color-cream: #fdf6e3;
  --color-green: #10b981;
  --color-green-brown: #8a6e1eb3;

  /* Font */
  --lexend:
    Lexend, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
/* Outline all elements in red for debugging. */
/* * {
  outline: 1px solid red !important;
} */

body {
  background-color: var(--color-lightblue);
  color: var(--color-verydarkblue);
}
div.main-wrapper {
  display: grid;
  grid-template-columns: minmax(360px, 100%);
  grid-template-rows: minmax(10vh, 100%);
  gap: 10px;
}

/* Header styles */
header {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  padding-top: 10px;
  flex-wrap: wrap;
}
.page-title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  padding-top: 20px;
}
h1.page-title {
  position: relative;
  z-index: 10;
  color: var(--color-verydarkblue);
  font-family: var(--lexend);
  font-size: 2.2rem;
  pointer-events: none;
}
.oval-back {
  position: absolute;
  width: 360px;
  height: 130px;
  background: linear-gradient(
    45deg,
    rgba(245, 185, 82, 0.6),
    rgba(245, 185, 82, 0.2)
  );
  border-radius: 50%;
  transform: rotate(15deg);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  z-index: 8;
}
.oval-fore {
  position: absolute;
  width: 320px;
  height: 140px;
  background: linear-gradient(
    -45deg,
    rgba(0, 103, 181, 0.4),
    rgba(0, 103, 181, 0.1)
  );
  border-radius: 50%;
  transform: rotate(-15deg);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 9;
}
.search {
  font-size: 1.5rem;
}
button[data-dropdown="toggle"] {
  /* padding-top: 4px; */
  background: none;
  border-radius: 6px;
  border: none;
  padding: 5px 6px 2px 6px;
}
button[data-dropdown="toggle"]:hover,
button[data-dropdown="toggle"]:active {
  background: rgba(0, 103, 181, 0.2);
}
path {
  fill: var(--color-verydarkblue);
  stroke: var(--color-verydarkblue);
}
div.dropdown {
  margin-right: 12px;
  text-align: left;
}
.dropdown-list {
  position: absolute;
  z-index: 10;
  gap: 12px;
}
.dropdown-item {
  display: flex;
  gap: 8px;
  align-items: center;
  text-transform: uppercase;
  font-family: var(--lexend);
}
input#search {
  height: 2rem;
  border-radius: 6px;
  border: 1px solid var(--color-blue);
  padding-left: 5px;
  outline-offset: 0px;
}

.header-top-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.header-bottom-line {
  display: grid;
  grid-template-columns: auto 1fr auto 1fr;
  row-gap: 12px;
  column-gap: 6px;
  font-size: 1.5rem;
  align-items: center;
}
.header-bottom-line .data[data-id="date"] {
  grid-column: span 3;
}
.header-bottom-line img.card-icon {
  width: 24px;
}

/* Card styles */
.main-content {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  padding-top: 15px;
  letter-spacing: 1px;
}
@keyframes fadeIn {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}
.card-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: var(--color-white);
  height: max-content;
  width: 350px;
  border-radius: 12px;
  padding: 15px 15px 15px 15px;
  border-top: 6px solid var(--color-blue);
  box-shadow: 2px 2px 3px var(--color-green-brown);
  animation: fadeIn 400ms ease-in forwards; /* The animation is triggered when card-container is created. */
}
a {
  text-decoration: none;
}
h2 {
  margin: 0;
}
.header-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 310px;
}
.weather-icon {
  width: 60px;
  height: 60px;
}
.card-icon {
  width: 25px;
  height: 25px;
  filter: invert(11%) sepia(21%) saturate(4756%) hue-rotate(196deg)
    brightness(96%) contrast(111%);
  /* Used css filter generator to imitate page title color */
}
.temp-container,
.info-line,
.info-container {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.info-line .data[data-id="high"] {
  padding-left: 33px;
}

.info-line.wind {
  display: grid;
  grid-template-columns: auto 207px auto;
}
.hourly-btn {
  justify-self: right;
  width: 70px;
  height: 26px;
  border-radius: 8px;
  letter-spacing: 1px;
  background: #ccc;
  background: rgba(0, 103, 181, 0.15);
  border-radius: 6px;
  border: 1px solid var(--color-blue);
  color: inherit;
  font-weight: 600;
}
.hourly-btn:hover {
  background: rgba(0, 103, 181, 0.3);
}
.hourly-btn:active {
  background: rgba(0, 103, 181, 0.4);
}
.data[data-id="wind"] {
  justify-self: left;
}
.info-container {
  gap: 12px;
}
.temp {
  font-size: 2rem;
}
.conditions {
  font-size: 1.2rem;
}

/* Dropdown */
ul.dropdown-list.visible {
  margin-top: 2px;
  margin-bottom: 2px;
}
.dropdown {
  user-select: none;
}

/* Toggle switch styles */
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 66px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-verydarkblue);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: rgb(233, 190, 120);
}

input:focus + .slider {
  box-shadow: 0 0 1px rgb(233, 190, 120);
}

input:checked + .slider:before {
  -webkit-transform: translateX(32px);
  -ms-transform: translateX(32px);
  transform: translateX(32px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Hourly styles */
.hourly-container {
  display: none;
}
.hourly-container.visible {
  justify-content: center;
  display: flex;
  gap: 20px;
  background-color: var(--color-white);
  height: max-content;
  min-width: 190px;
  max-width: 330px;
  border-radius: 12px;
  padding: 15px 0;
  border-top: 6px solid var(--color-blue);
  box-shadow: 2px 2px 3px var(--color-green-brown);
  animation: fadeIn 400ms ease-in forwards;
  margin-left: 16px;
}
.hourly-container .chevron {
  border: none;
  background: var(--color-blue);
  opacity: 0.2;
  width: 60px;
}
.hourly-container .chevron:hover {
  opacity: 1;
  transition: 300ms;
}
.chevron[data-id="left"] {
  border-radius: 0 50% 50% 0;
}
.chevron[data-id="right"] {
  border-radius: 50% 0 0 50%;
}
.hour-card-list {
  display: flex;
  gap: 20px;
  overflow-x: scroll;
}
.hour-card-container {
  display: grid;
  grid-template-columns: auto 1fr;
  justify-items: center;
  padding-top: 10px;
  row-gap: 4px;
  animation: fadeIn 400ms ease-in forwards;
}
/* .hour-card-container.visible {
  display: grid;
  grid-template-columns: auto 1fr;
  justify-items: center;
  padding-top: 10px;
  row-gap: 4px;
  animation: fadeIn 400ms ease-in forwards;
} */
.hour-card-container [data-id="time"],
.hour-card-container [data-id="temp"],
.hour-card-container .weather-icon {
  grid-column: span 2;
}
.hour-card-container [data-id="time"] {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4CAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,gDAAgD;EAChD,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;;EAE7B,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;;EAE9B,SAAS;EACT;;wEAEsE;AACxE;AACA,+CAA+C;AAC/C;;GAEG;;AAEH;EACE,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,sCAAsC;EACtC,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb;;;;GAIC;EACD,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb;;;;GAIC;EACD,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,uCAAuC;EACvC,gDAAgD;EAChD,wCAAwC,EAAE,+DAA+D;AAC3G;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ;kCACgC;EAChC,0DAA0D;AAC5D;AACA;;;EAGE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,gDAAgD;EAChD,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,wCAAwC;AAC1C;AACA;;;;;;;GAOG;AACH;;;EAGE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["@font-face {\r\n  font-family: Lexend;\r\n  src: url(\"./fonts/Lexend-Bold.ttf\");\r\n}\r\n\r\n:root {\r\n  /* Primary colors */\r\n  --color-white: #ffffff;\r\n  --color-lightcream: #fffefa;\r\n  /* --color-blue: #0078d4; \"The over-used blue\" */\r\n  --color-blue: #0067b5;\r\n  --color-orange: #f59e0b;\r\n  --color-darkblue: #0067a3;\r\n  --color-verydarkblue: #001944;\r\n\r\n  /* Supporting colors */\r\n  --color-gray: #6b7280;\r\n  --color-lightblue: #bedaff5e;\r\n  --color-cream: #fdf6e3;\r\n  --color-green: #10b981;\r\n  --color-green-brown: #8a6e1eb3;\r\n\r\n  /* Font */\r\n  --lexend:\r\n    Lexend, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\r\n}\r\n/* Outline all elements in red for debugging. */\r\n/* * {\r\n  outline: 1px solid red !important;\r\n} */\r\n\r\nbody {\r\n  background-color: var(--color-lightblue);\r\n  color: var(--color-verydarkblue);\r\n}\r\ndiv.main-wrapper {\r\n  display: grid;\r\n  grid-template-columns: minmax(360px, 100%);\r\n  grid-template-rows: minmax(10vh, 100%);\r\n  gap: 10px;\r\n}\r\n\r\n/* Header styles */\r\nheader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  padding-top: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n.page-title-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 160px;\r\n  padding-top: 20px;\r\n}\r\nh1.page-title {\r\n  position: relative;\r\n  z-index: 10;\r\n  color: var(--color-verydarkblue);\r\n  font-family: var(--lexend);\r\n  font-size: 2.2rem;\r\n  pointer-events: none;\r\n}\r\n.oval-back {\r\n  position: absolute;\r\n  width: 360px;\r\n  height: 130px;\r\n  background: linear-gradient(\r\n    45deg,\r\n    rgba(245, 185, 82, 0.6),\r\n    rgba(245, 185, 82, 0.2)\r\n  );\r\n  border-radius: 50%;\r\n  transform: rotate(15deg);\r\n  backdrop-filter: blur(10px);\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\r\n  z-index: 8;\r\n}\r\n.oval-fore {\r\n  position: absolute;\r\n  width: 320px;\r\n  height: 140px;\r\n  background: linear-gradient(\r\n    -45deg,\r\n    rgba(0, 103, 181, 0.4),\r\n    rgba(0, 103, 181, 0.1)\r\n  );\r\n  border-radius: 50%;\r\n  transform: rotate(-15deg);\r\n  backdrop-filter: blur(10px);\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\r\n  z-index: 9;\r\n}\r\n.search {\r\n  font-size: 1.5rem;\r\n}\r\nbutton[data-dropdown=\"toggle\"] {\r\n  /* padding-top: 4px; */\r\n  background: none;\r\n  border-radius: 6px;\r\n  border: none;\r\n  padding: 5px 6px 2px 6px;\r\n}\r\nbutton[data-dropdown=\"toggle\"]:hover,\r\nbutton[data-dropdown=\"toggle\"]:active {\r\n  background: rgba(0, 103, 181, 0.2);\r\n}\r\npath {\r\n  fill: var(--color-verydarkblue);\r\n  stroke: var(--color-verydarkblue);\r\n}\r\ndiv.dropdown {\r\n  margin-right: 12px;\r\n  text-align: left;\r\n}\r\n.dropdown-list {\r\n  position: absolute;\r\n  z-index: 10;\r\n  gap: 12px;\r\n}\r\n.dropdown-item {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  text-transform: uppercase;\r\n  font-family: var(--lexend);\r\n}\r\ninput#search {\r\n  height: 2rem;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--color-blue);\r\n  padding-left: 5px;\r\n  outline-offset: 0px;\r\n}\r\n\r\n.header-top-line {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n.header-bottom-line {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto 1fr;\r\n  row-gap: 12px;\r\n  column-gap: 6px;\r\n  font-size: 1.5rem;\r\n  align-items: center;\r\n}\r\n.header-bottom-line .data[data-id=\"date\"] {\r\n  grid-column: span 3;\r\n}\r\n.header-bottom-line img.card-icon {\r\n  width: 24px;\r\n}\r\n\r\n/* Card styles */\r\n.main-content {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  align-content: center;\r\n  justify-content: center;\r\n  padding-top: 15px;\r\n  letter-spacing: 1px;\r\n}\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0.2;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n.card-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  background-color: var(--color-white);\r\n  height: max-content;\r\n  width: 350px;\r\n  border-radius: 12px;\r\n  padding: 15px 15px 15px 15px;\r\n  border-top: 6px solid var(--color-blue);\r\n  box-shadow: 2px 2px 3px var(--color-green-brown);\r\n  animation: fadeIn 400ms ease-in forwards; /* The animation is triggered when card-container is created. */\r\n}\r\na {\r\n  text-decoration: none;\r\n}\r\nh2 {\r\n  margin: 0;\r\n}\r\n.header-line {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 310px;\r\n}\r\n.weather-icon {\r\n  width: 60px;\r\n  height: 60px;\r\n}\r\n.card-icon {\r\n  width: 25px;\r\n  height: 25px;\r\n  filter: invert(11%) sepia(21%) saturate(4756%) hue-rotate(196deg)\r\n    brightness(96%) contrast(111%);\r\n  /* Used css filter generator to imitate page title color */\r\n}\r\n.temp-container,\r\n.info-line,\r\n.info-container {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n.info-line .data[data-id=\"high\"] {\r\n  padding-left: 33px;\r\n}\r\n\r\n.info-line.wind {\r\n  display: grid;\r\n  grid-template-columns: auto 207px auto;\r\n}\r\n.hourly-btn {\r\n  justify-self: right;\r\n  width: 70px;\r\n  height: 26px;\r\n  border-radius: 8px;\r\n  letter-spacing: 1px;\r\n  background: #ccc;\r\n  background: rgba(0, 103, 181, 0.15);\r\n  border-radius: 6px;\r\n  border: 1px solid var(--color-blue);\r\n  color: inherit;\r\n  font-weight: 600;\r\n}\r\n.hourly-btn:hover {\r\n  background: rgba(0, 103, 181, 0.3);\r\n}\r\n.hourly-btn:active {\r\n  background: rgba(0, 103, 181, 0.4);\r\n}\r\n.data[data-id=\"wind\"] {\r\n  justify-self: left;\r\n}\r\n.info-container {\r\n  gap: 12px;\r\n}\r\n.temp {\r\n  font-size: 2rem;\r\n}\r\n.conditions {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* Dropdown */\r\nul.dropdown-list.visible {\r\n  margin-top: 2px;\r\n  margin-bottom: 2px;\r\n}\r\n.dropdown {\r\n  user-select: none;\r\n}\r\n\r\n/* Toggle switch styles */\r\n/* The switch - the box around the slider */\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 66px;\r\n  height: 34px;\r\n}\r\n\r\n/* Hide default HTML checkbox */\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n/* The slider */\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: var(--color-verydarkblue);\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 26px;\r\n  width: 26px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: white;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n}\r\n\r\ninput:checked + .slider {\r\n  background-color: rgb(233, 190, 120);\r\n}\r\n\r\ninput:focus + .slider {\r\n  box-shadow: 0 0 1px rgb(233, 190, 120);\r\n}\r\n\r\ninput:checked + .slider:before {\r\n  -webkit-transform: translateX(32px);\r\n  -ms-transform: translateX(32px);\r\n  transform: translateX(32px);\r\n}\r\n\r\n/* Rounded sliders */\r\n.slider.round {\r\n  border-radius: 34px;\r\n}\r\n\r\n.slider.round:before {\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Hourly styles */\r\n.hourly-container {\r\n  display: none;\r\n}\r\n.hourly-container.visible {\r\n  justify-content: center;\r\n  display: flex;\r\n  gap: 20px;\r\n  background-color: var(--color-white);\r\n  height: max-content;\r\n  min-width: 190px;\r\n  max-width: 330px;\r\n  border-radius: 12px;\r\n  padding: 15px 0;\r\n  border-top: 6px solid var(--color-blue);\r\n  box-shadow: 2px 2px 3px var(--color-green-brown);\r\n  animation: fadeIn 400ms ease-in forwards;\r\n  margin-left: 16px;\r\n}\r\n.hourly-container .chevron {\r\n  border: none;\r\n  background: var(--color-blue);\r\n  opacity: 0.2;\r\n  width: 60px;\r\n}\r\n.hourly-container .chevron:hover {\r\n  opacity: 1;\r\n  transition: 300ms;\r\n}\r\n.chevron[data-id=\"left\"] {\r\n  border-radius: 0 50% 50% 0;\r\n}\r\n.chevron[data-id=\"right\"] {\r\n  border-radius: 50% 0 0 50%;\r\n}\r\n.hour-card-list {\r\n  display: flex;\r\n  gap: 20px;\r\n  overflow-x: scroll;\r\n}\r\n.hour-card-container {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  justify-items: center;\r\n  padding-top: 10px;\r\n  row-gap: 4px;\r\n  animation: fadeIn 400ms ease-in forwards;\r\n}\r\n/* .hour-card-container.visible {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  justify-items: center;\r\n  padding-top: 10px;\r\n  row-gap: 4px;\r\n  animation: fadeIn 400ms ease-in forwards;\r\n} */\r\n.hour-card-container [data-id=\"time\"],\r\n.hour-card-container [data-id=\"temp\"],\r\n.hour-card-container .weather-icon {\r\n  grid-column: span 2;\r\n}\r\n.hour-card-container [data-id=\"time\"] {\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
